<template>
    <div class="deal-container">
        <configuration-duplicate-deal :raw-groups="groupsRaw" />
        <change-responsible-in-bulk :raw-groups="groupsRaw" />
    </div>
</template>
<script>
    import ConfigurationDuplicateDeal from './cards/duplicate-deal'
    import ChangeResponsibleInBulk from './cards/change-responsible-in-bluk'
    import { groups } from '@/services/axios'

    export default {
        name: 'configuration-business-general',

        components: {
            ConfigurationDuplicateDeal,
            ChangeResponsibleInBulk
        },

        data() {
            return {
                groupsRaw: []
            }
        },

        async created() {
            await this.fetchGroups()
        },
        methods: {
            fetchGroups() {
              groups.getGroups()
                .then(({ data }) => {
                  this.groupsRaw = data
                    .filter(group => group.name !== 'system')
                    .map(group => ({
                      id: group.id,
                      name: group.name,
                      permissions: group.permissions
                    }));
                })
                .catch((error) => {
                  if (error.data?.msg) {
                    this.$toastr.e(error.data.msg);
                  }
                });
            }

      }
    }
</script>

<style lang="stylus" scoped>
    @import './styles.styl'
</style>
